import {
  PENDING_MESSAGE_MAX_ATTEMPTS,
  PENDING_MESSAGE_TTL_MS,
} from "../constants/chat";

// NOTE: NSAI-5042 — pure decision for what to do with a buffered (pending)
// message at flush time. Extracted so web and mobile share one policy and the
// branch matrix is unit-testable without a live socket:
//  - "expire":  older than PENDING_MESSAGE_TTL_MS — surface a send failure
//               instead of the previous silent splice.
//  - "give-up": retried PENDING_MESSAGE_MAX_ATTEMPTS times without an ack —
//               surface a send failure instead of retrying forever.
//  - "send":    still eligible for a retry.
export interface IPendingSendDecisionProps {
  ageMs: number;
  attempts: number;
}

export type TPendingSendDecision = "send" | "expire" | "give-up";

export const decidePendingSend = (
  props: IPendingSendDecisionProps,
): TPendingSendDecision => {
  if (props.ageMs >= PENDING_MESSAGE_TTL_MS) return "expire";
  if (props.attempts >= PENDING_MESSAGE_MAX_ATTEMPTS) return "give-up";
  return "send";
};
